import { useApp } from "../../../../hooks/useApp";
import Autocomplete from "@mui/material/Autocomplete";
import { Fragment, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Tooltip from "@mui/material/Tooltip";
import Gobutton from "../../../../components/Gobutton";
import {
  Box,
  Card,
  CardMedia,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Stack,
  TextField,
  Typography,
  Checkbox,
  Button
} from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import FactoryIcon from "@mui/icons-material/Factory";
import InfoIcon from "@mui/icons-material/Info";
import SvgIcon from "@mui/material/SvgIcon"; 
import { ReactComponent as TulipLibraryWhite } from "../../../../svgs/tulipLibraryWhite.svg";

const style = {
  p: 0,
  width: "100%",
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  backgroundColor: "#FFF",
  fontSize: "6px",
};

export default function StepFour({ asset, setAsset }) {
  const { aiFeatures } = useApp("ai_features");

  const [dropDown, setDropDown] = useState(null);

  const ensureChildrenArray = (currentAsset) => {
    return {
      ...currentAsset,
      AiFeatures: Array.isArray(currentAsset?.AiFeatures)
        ? currentAsset?.AiFeatures
        : [],
    };
  };

  function handleAdd() {
    const updatedAsset = ensureChildrenArray(asset);

    if (!dropDown) {
      alert("Please select an asset before adding.");
      return;
    }

    if (updatedAsset?.AiFeatures?.some((child) => child.id === dropDown.id)) {
      alert("This asset is already added.");
      return;
    }

    if (!(updatedAsset?.AiFeatures && updatedAsset?.AiFeatures?.length < 4)) {
      alert("You can only add max 4 ai features");
      return;
    }

    const newChild = {
      id: dropDown.id,
      Title: dropDown.Title,
      Left: "50%",
      Top: "50%",
      flow: false,
      color: "#b0e0e6",
    };

    setAsset((prevAsset) => ({
      ...ensureChildrenArray(prevAsset),
      AiFeatures: [...ensureChildrenArray(prevAsset)?.AiFeatures, newChild],
    }));

    setDropDown(null);
  }

  const moveAsset = (index, direction) => {
    const updatedAsset = ensureChildrenArray(asset);
    const newIndex = direction === "up" ? index - 1 : index + 1;
    if (newIndex >= 0 && newIndex < updatedAsset?.AiFeatures?.length) {
      const newChildren = [...updatedAsset?.AiFeatures];
      const [movedItem] = newChildren.splice(index, 1);
      newChildren.splice(newIndex, 0, movedItem);
      setAsset({ ...updatedAsset, AiFeatures: newChildren });
    }
  };

  return (
    <Grid container sx={{ flexDirection: "row", gap: 4 }}>
      <Grid
        item
        xs={12}
        sm={6}
        md={7}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Grid
          item
          xs
          sx={{ backgroundColor: "background.default" }}
          marginY={"auto"}
          borderRadius={"0px 8px 8px 8px"}
          padding={5}
        >
          <Grid container gap={2}>
            <Grid item xs={12}>
              <Typography color={"customColors.default"} variant="h8">
                {asset.Title}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} alignItems={"center"}>
              <Card sx={{ boxShadow: "none", backgroundColor: "transparent" }}>
                <CardMedia
                  component="img"
                  image={asset.img}
                  style={{
                    boxShadow: "none",
                    maxWidth: "100%", // Set width to 100% to fill the entire width of the Card
                    maxHeight: "80vh",
                    objectFit: "cover", // Maintain aspect ratio while covering the entire space
                    objectPosition: "center", // Center the image within the CardMedia
                  }}
                />
              </Card>
            </Grid>
            <Grid item xs>
              <Typography fontSize={"small"} color={"customColors.default"}>
                Key Features
              </Typography>
              {asset.Features && asset.Features[0] !== "" && (
                <List aria-label="mailbox folders" sx={style}>
                  {asset.Features.map((feature, index) => (
                    <Fragment key={index}>
                      <ListItem>
                        <ListItemText
                          sx={{ color: "customColors.defaultLight" }}
                          primary={feature}
                        />
                      </ListItem>
                      {index < asset.Features.length - 1 && (
                        <Divider component="li" />
                      )}
                    </Fragment>
                  ))}
                </List>
              )}
            </Grid>
            <Grid
              container
              justifyContent={"right"}
              alignItems={"bottom"}
              gap={2}
            >
              {asset.appUrl && (
                <Gobutton
                  text={"Open the App"}
                  startIcon={<ExitToAppIcon />}
                  url={{ type: "beacon", url: asset.appUrl }}
                />
              )}
              {asset.editorUrl && (
                <Gobutton
                  text={"Open the Editor"}
                  startIcon={<LaptopMacIcon />}
                  url={{ type: "beacon", url: asset.editorUrl }}
                />
              )}
              {asset.contentUrl && (
                <Gobutton
                  text={"More info"}
                  startIcon={<InfoIcon />}
                  url={{ type: "content", url: asset.contentUrl }}
                />
              )}
              {asset.video && (
                <Gobutton
                  text={"Play the Video"}
                  startIcon={<InfoIcon />}
                  url={{ type: "video", url: asset.video }}
                />
              )}
              {asset.tulipLibrary && (
                <Gobutton
                  text={"Open in Tulip Library"}
                  startIcon={
                    <SvgIcon
                      className="tulipLibrary"
                      inheritViewBox
                      sx={{
                        height: "18px",
                        width: "auto",
                        color: "customColors.white",
                      }}
                      component={TulipLibraryWhite}
                    />
                  }
                  url={{ type: "beacon", url: asset.tulipLibrary }}
                />
              )}
              {asset.Type === "factory" && (
                <Gobutton
                  text={"Explore the Factory"}
                  startIcon={<FactoryIcon />}
                  url={"factory"}
                />
              )}
              {asset.Type === "megafactory" && (
                <Gobutton
                  text={"Explore the Factory"}
                  startIcon={<FactoryIcon />}
                  url={"megafactory"}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs>
        <Stack direction={"column"} gap={1} sx={{ height: "100%" }}>
          <Typography sx={{ mt: 2 }}>AI Features</Typography>
          <Stack direction={"row"}>
            {aiFeatures && (
              <Autocomplete
                disablePortal
                id="aiFeatureSelect"
                options={aiFeatures}
                getOptionLabel={(option) => option.Title || ""}
                sx={{ width: "100%" }}
                size="small"
                value={dropDown}
                onChange={(event, newValue) => {
                  setDropDown(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Title" />
                )}
              />
            )}
            <Button onClick={handleAdd}>Add</Button>
          </Stack>

          <Box
            sx={{
              border: "1px solid #BDBDBD",
              height: "100%",
              paddingBlock: 2,
              paddingInline: 1,
              borderRadius: 2,
            }}
          >
            {asset?.AiFeatures &&
              asset?.AiFeatures.length > 0 &&
              asset?.AiFeatures.map((child, thisIndex) => {
                return (
                  <Stack
                    key={thisIndex}
                    direction={"column"}
                    spacing={1}
                    marginBottom={2}
                    borderBottom={1}
                    borderColor={"#BDBDBD"}
                    pb={1}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography>{child.Title}</Typography>
                      <div className="flex align-items-center">
                        {child.flow && (
                          <>
                            <IconButton
                              aria-label="down"
                              size="small"
                              onClick={() => moveAsset(thisIndex, "down")}
                              disabled={
                                thisIndex === asset?.AiFeatures.length - 1
                              }
                            >
                              <ArrowDownwardIcon fontSize={"small"} />
                            </IconButton>
                            <IconButton
                              aria-label="up"
                              size="small"
                              onClick={() => moveAsset(thisIndex, "up")}
                              disabled={thisIndex === 0}
                            >
                              <ArrowUpwardIcon fontSize={"small"} />
                            </IconButton>
                          </>
                        )}
                        {/* <Box
                          onClick={() =>
                            setOpenPickerIndex(isOpen ? null : thisIndex)
                          }
                          sx={{
                            width: 24,
                            height: 24,
                            borderRadius: "4px",
                            backgroundColor: child.color || "#b0e0e6",
                            border: "1px solid #ccc",
                            cursor: "pointer",
                            mr: 1,
                          }}
                        /> */}
                        <Tooltip title="Flow" placement="left">
                          <Checkbox
                            checked={child.flow || false}
                            name="flow"
                            onClick={(e) => {
                              setAsset((prevAsset) => {
                                const updatedPrev =
                                  ensureChildrenArray(prevAsset);
                                const newSuites = [...updatedPrev?.AiFeatures];
                                newSuites[thisIndex] = {
                                  ...newSuites[thisIndex],
                                  flow: e.target.checked,
                                };
                                return {
                                  ...updatedPrev,
                                  AiFeatures: newSuites,
                                };
                              });
                            }}
                          />
                        </Tooltip>
                        <IconButton
                          aria-label="delete"
                          onClick={() => {
                            const newChildren = asset?.AiFeatures.filter(
                              (_, index) => index !== thisIndex
                            );
                            setAsset({ ...asset, AiFeatures: newChildren });
                          }}
                        >
                          <DeleteIcon fontSize={"small"} />
                        </IconButton>
                      </div>
                    </Stack>

                    {/* Toggle Color Picker */}
                    {/* {isOpen && (
                      <ClickAwayListener
                        onClickAway={() => setOpenPickerIndex(null)}
                      >
                        <Box className="color-picker">
                          <SketchPicker
                            color={child.color || "#b0e0e6"}
                            onChangeComplete={(color) =>
                              handleChildColorChange(thisIndex, color.hex)
                            }
                          />
                        </Box>
                      </ClickAwayListener>
                    )} */}
                  </Stack>
                );
              })}
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
}
